import { countryList } from '../config/Config';

export const getCountryName = (countryCode) => {
    if (!countryCode) {
        return null;
    }
    return countryList[countryCode];
}
